export default {
  loading: (state) => state.loading,
  routerJump: (state) => state.routerJump,
  shortcuts: (state) => state.shortcuts,
  settingName: (state) => state.settingName,
  isLoggingOut: (state) => state.isLoggingOut
}
